export default __webpack_public_path__ + "static/media/GG Logo New - White.4de60453.svg";